import React, {useEffect, useRef, useState} from 'react';
import {analytics, eventEmitter, isAuth} from '../../../common/baseData';
import {useInView} from 'react-intersection-observer';
import ViewedProduct from './viewedProduct/ViewedProduct';

function Viewed(props) {
  const viewedNodeRef = useRef(null);
  const itemClassName = props.variant === 'basket'
    ? 'desktop:basis-[40%] desktop:max-w-[calc(40%-1px)]'
    : 'xl:basis-1/4 xl:max-w-[calc(25%-1px)] 2xl:basis-1/5 2xl:max-w-[calc(20%-1px)]';

  const {ref: inViewRef, inView} = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const setViewedRef = node => {
    viewedNodeRef.current = node;
    inViewRef(node);
  };

  useEffect( () => {
    if (!inView) return;
    init();
  }, [inView]);

  useEffect(() => {
    if (!(viewedNodeRef.current instanceof HTMLElement)) return;

    eventEmitter.emit('handleWishlistItems', {
      node: viewedNodeRef.current.querySelectorAll('[data-container="favorite"]'),
      range: props.actionRange || 'product',
    });

    eventEmitter.emit('handleCompareItems', {
      node: viewedNodeRef.current.querySelectorAll('[data-container="compare"]'),
      range: props.actionRange || 'product',
    });
  }, [props.itemsList]);

  async function init() {
    let item_ids = [];

    props.itemsList.forEach(item => {
      if (Number(item.ID)) item_ids.push(Number(item.ID));
    });

    if (item_ids.length)
      analytics.viewItemList(item_ids, 'Viewed Products', 'viewed_products').
        then(response => {
          analytics.view_item_list(response.events[0].params);
          console.info(response);
        }).
        catch(reason => (console.error(reason)));
  }

  function onClick(item_id, url) {
    analytics.selectItem(item_id, 'Viewed Products', 'viewed_products').
        then(response => {
          analytics.select_item(response.data.params);
          console.info(response, item_id);
          window.location.href = url;
        }).
        catch(reason => {
          console.error(reason);
          window.location.href = url;
        });
  }

  function getMessage(code) {
    return props.hasOwnProperty('messages') &&
    props.messages.hasOwnProperty(code) ?
        props.messages[code] : `lang message: ${code} not defined`;
  }

  return (
          <div ref={setViewedRef}>
            {
              Array.isArray(props.itemsList) && props.itemsList.length ?
                  <>
                    <div className={`pb-3 flex justify-between items-baseline desktop:justify-normal desktop:gap-3 desktop:px-0 ${
                      props.variant !== 'product' && props.variant !== 'catalog' ? 'pr-[25px]' : ''
                    }`}>
                      <div
                          className="text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">{getMessage(
                          'CT_CPV_TPL_YOU_VIEWED')}</div>
                      {
                        isAuth ?
                          <a href={props.personalLink}
                             className="inline-block w-auto text-blue-primary text-[14px] leading-[21px] underline desktop:text-[16px] desktop:leading-[24px] hover:no-underline">
                            {getMessage('CT_CPV_TPL_ALL_VIEWED')}
                          </a> :
                          <></>
                      }
                    </div>
                    <ul
                      className="pl-0 pr-1 flex overflow-x-scroll scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar pb-[45px]">
                      {props.itemsList.map((product, index) => (
                        <ViewedProduct
                          {...product}
                          key={`viewed-${product.ID}`}
                          rootClassName={`relative flex flex-col shrink-0 w-[220px] py-8 px-3.5 border border-solid border-grey-5 desktop:px-5 ${itemClassName} ${
                            index === props.itemsList.length - 1 ? '' : 'border-r-0'
                          }`}
                          getMessage={getMessage}
                          onClick={onClick}
                        />
                      ))}
                    </ul>
                  </> :
                <></>
            }
          </div>
  );
}

export default Viewed;